import { IHideNotification } from "../models";
import { HIDE_NOTIFICATION } from "../types";

export default (index: number): IHideNotification => ({
    type: HIDE_NOTIFICATION,
    payload: index,
});
